// extracted by mini-css-extract-plugin
export default {"characteristics":"IconBottleCharacteristics_characteristics__RShW-","icon":"IconBottleCharacteristics_icon__iGyEo"};